import React from 'react'

/**
 * Inline form/field error text. Renders an accessible `role="alert"` paragraph
 * with the shared error styling; pass extra layout classes (e.g. centering)
 * via `className`. Call sites guard on the message themselves, matching the
 * conditional-render pattern used across the login flow.
 */
export const FormError = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement>
>(({ className = '', children, ...props }, ref) => {
  return (
    <p
      ref={ref}
      role="alert"
      className={`text-xs leading-relaxed text-red-600 ${className}`}
      {...props}
    >
      {children}
    </p>
  )
})

FormError.displayName = 'FormError'
